export default __webpack_public_path__ + "img/729e55a4d5aeda8c6c8b963f028b95e2.png";